const bundle = {
  close: () => '[PX][Close é]',
  error: () => '[PX][Error é]',
  warn: () => '[PX][Warning é]',
  info: () => '[PX][Info é]',
  confirmation: () => '[PX][Confirmation é]',
  progressIndeterminate: () => '[PX][In Progress é]',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    '[PX][Between ' + p['FROM_SECTION'] + ' and ' + p['TO_SECTION'] + '. éëžéëžé]',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    '[PX][' + p['SECTION'] + '. No matching section found. éëžéëž]',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => '[PX][Press enter to select value. éëž]',
  indexer_touchInstructionText: () =>
    '[PX][Double tap and hold to enter gesture mode, then drag up or down to adjust value. éëžéëžéëžéëžéëžéëžé]',
  inputPassword_show: () => '[PX][Show Password é]',
  inputPassword_hide: () => '[PX][Hide Password é]',
  inputPassword_hidden: () => '[PX][Password Hidden é]',
  formControl_clear: () => '[PX][Clear é]',
  formControl_loading: () => '[PX][Loading é]',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    '[PX][Maximum length ' + p['MAX_LENGTH'] + ' exceeded. éëžéëž]',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    '[PX][' + p['CHARACTER_COUNT'] + ' characters left. éëžéë]',
  select_noMatchesFound: () => '[PX][No matches found. é]',
  select_oneMatchFound: () => '[PX][One match found é]',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    '[PX][' + p['TOTAL_SIZE'] + ' matches found éë]',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    '[PX][' + p['TOTAL_SIZE'] + ' or more matches found éëžéë]',
  selectMultiple_showSelectedValues: () => '[PX][Show selected values only. éë]',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    '[PX][' + p['VALUE_COUNT'] + ' values selected. éëžé]',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selector_selected: () => '[PX][Checkbox checked é]',
  selector_unselected: () => '[PX][Checkbox not checked é]',
  userAssistance_learnMore: () => '[PX][Learn more é]',
  userAssistance_required: () => '[PX][Required é]',
  filePicker_singleFileUploadError: () => '[PX][Upload one file at a time éë]',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    "[PX][You can't upload files of type " + p['fileType'] + ' éëžéëžé]',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    "[PX][You can't upload files of type: " + p['fileTypes'] + ' éëžéëžé]',
  filePicker_unknownFileTypeUploadError: () => '[PX][unknown é]',
  filePicker_dropzonePrimaryText: () => '[PX][Drag and Drop é]',
  filePicker_dropzoneSecondaryText: () => '[PX][Select a file or drop one here éëžé]',
  filePicker_dropzoneSecondaryTextMultiple: () => '[PX][Select or drop files here éë]',
  filePicker_addFiles: () => '[PX][Add Files é]',
  plural_separator: () => ', ',
  inputNumber_increase: () => '[PX][Increase é]',
  inputNumber_decrease: () => '[PX][Decrease é]',
  inputNumber_converterParseError: () => 'Enter a number.',
  noData_message: () => '[PX][No items to display é]',
  message_navigationFromMessagesRegion: () =>
    '[PX][Entering messages region. Press F6 to navigate back to prior focused element. éëžéëžéëžéëžéëžéëž]',
  message_navigationToMessagesRegion: () =>
    '[PX][Messages region has new messages. Press F6 to navigate to the most recent message region. éëžéëžéëžéëžéëžéëžéëž]',
  messageToast_allMessagesClosed: () => '[PX][All toast messages are closed. éëžé]'
};
export default bundle;
